<app-nav></app-nav>
<div class="agent-screen">
    <div class='partner-tabs'>
        <ul>
            <li routerLink='/policy-booking'>Policy-Booking</li>
            <li routerLinkActive="active" routerLink='/agent-dash/dashbaord'>Dashboard</li>
            <li routerLinkActive="active" routerLink='/agent-dash/statistics'>Statistics</li>
            <li routerLinkActive="active" routerLink='/agent-dash/retrieve-quote'>Retrieve Quotes</li>
        </ul>
    </div>
    <router-outlet></router-outlet>
</div>